import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  const userRole = localStorage.getItem("role") ?? "";
  const isAuthorized = allowedRoles.includes(userRole);

  return isAuthorized ? (
    children
  ) : (
    <Navigate to="/no-permission"/>
  );
};

export default ProtectedRoute;
